import request from '@/utils/request'

export function fetchBuildFile(id) {
  return request({
    url: `/files/build/${id}`,
    method: 'get'
  })
}

export function fetchAreaFiles(query) {
  return request({
    url: '/files/list',
    method: 'get',
    params: query
  })
}

export function fetchCustomerFiles(id) {
  return request({
    url: `/files/customer/${id}`,
    method: 'get',
  })
}

export function fetchFile(id) {
  return request({
    url: `/files/${id}`,
    method: 'get'
  })
}

export function updateFile(id, data) {
  return request({
    url: `/files/${id}`,
    method: 'put',
    data
  })
}
